import React from 'react';
import Layout from '../util/layout';
import background from '../img/7.png';

const FDL = () => {
	return(
        <Layout title="BSC Rwanda">
            <div className="page-content">
                <section data-padding="top">
                    <div className="container">
                        <div data-aos="fade-up" className="row aos-init aos-animate">
                            <div className="col-12">
                                <div className="sectiontitle-element--center">
                                    <h2>Customer Testimony FDL Power</h2>
                                </div>
                                <div className="sectiontitle-element">
                                    <p data-aos="fade-up" data-aos-delay="200" className="aos-init aos-animate">FDL service engineers previously used triplicate paper forms to service customer generators. Today all service forms are completed using Amazon Digital Office – increasing speed of the process by over 1 week, reduced errors on completed forms and ability to bill customers earlier.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-lg" data-padding="xstop">
                            <div data-aos="zoom-in" className="col-12 col-lg-6 aos-init">
                                <div className="wrapimage-element--square">
                                    <div className="image">
                                        <img src={background}  alt="" />
                                    </div>
                                </div>
                            </div>
                            <div data-aos="fade" data-aos-delay="200" className="col-12 col-lg-6 aos-init">
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>The Problem</h6>
                                            <p>Frank Driver Limited (FDL) had traditionally used paper forms (triplicates) during the process of servicing customer’s generators. This involved the engineer  completing a long and complicated form during the process of servicing.</p>
                                            <p>A number of problems such as errors, omissions, unclear hand writing, forms going missing before they got back to the head office for processing, the forms were posted and any errors had to be addressed and corrected after a number of days.</p>
                                            <p>This situation meant that customers were invoiced much later than necessary and there were unforeseen costs associated with the paper process.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>The Solutions</h6>
                                            <p>Having contacted Amazon Digital Office technicials their service forms were converted in a number of minutes, the engineers were provided with iPads and immediately started completing forms and submitting them remotely from customer locations for instant processing and the customers were invoiced over 1 week earlier than previously done with the paper process.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>Outcome</h6>
                                            <p>Due to the new design of the paperless forms whereby mandatory fields were included, alerts, reminders, drop down menus, absolute data selections and options were introduced, this meant that errors were effectively eradicated and engineers were able to seamlessly complete forms.</p>
                                            <p>Feedback from customers was positive with some saying there were impressed with the signature quality when they signed using the tablets and they were extremely impressed to receive their copy of the service form instantly via email directly from the engineer’s device whilst the engineer was still on site standing.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
}

export default FDL;